import React from 'react'
import { cn } from '../../utils'

const COUNTRIES = [
  { code: '+57', name: 'Colombia', flag: '🇨🇴' },
  { code: '+52', name: 'México', flag: '🇲🇽' },
  { code: '+51', name: 'Perú', flag: '🇵🇪' },
  { code: '+593', name: 'Ecuador', flag: '🇪🇨' },
  { code: '+56', name: 'Chile', flag: '🇨🇱' },
  { code: '+507', name: 'Panamá', flag: '🇵🇦' },
  { code: '+1', name: 'EEUU', flag: '🇺🇸' },
  { code: '+55', name: 'Brasil', flag: '🇧🇷' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪' },
  { code: '+502', name: 'Guatemala', flag: '🇬🇹' },
  { code: '+503', name: 'El Salvador', flag: '🇸🇻' },
  { code: '+504', name: 'Honduras', flag: '🇭🇳' },
  { code: '+506', name: 'Costa Rica', flag: '🇨🇷' },
  { code: '+591', name: 'Bolivia', flag: '🇧🇴' },
  { code: '+595', name: 'Paraguay', flag: '🇵🇾' },
  { code: '+598', name: 'Uruguay', flag: '🇺🇾' },
  { code: '+53', name: 'Cuba', flag: '🇨🇺' },
]

interface CountryCodeSelectProps {
  value: string
  onChange: (code: string) => void
  className?: string
}

const CountryCodeSelect: React.FC<CountryCodeSelectProps> = ({ value, onChange, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'h-12 w-28 rounded-md border-2 border-gray-400 bg-white px-2 text-base shadow-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-retri-blue focus-visible:ring-offset-2 appearance-none cursor-pointer',
        className
      )}
      aria-label="Código de país"
    >
      {COUNTRIES.map((country) => (
        <option key={country.code} value={country.code}>
          {country.flag} {country.code}
        </option>
      ))}
    </select>
  )
}

export default CountryCodeSelect
